import { useDynamicValuesListener } from './dynamic-values.hook';
import { useDashboardFiltersListener } from './dashboard-filters.hook';
import { useCurrentRecord } from './current-record';
import React, { createContext } from 'react';
import {
  DynamicValue,
  getDashboardFilters,
  getDynamicValues,
} from '../../../app/frontend/js/common/Constants';
import { noop } from 'lodash';
import { IDashletFilter } from '../../../app/frontend/js/common/utilities/sugar-filter-converter/sugar-filter-converter.interfaces';
import { ICurrentRecordType } from './current-record/current-record.interfaces';

export type SugarContextType = {
  dynamicValues: DynamicValue;
  dashboardFilters: IDashletFilter;
  currentRecord: ICurrentRecordType;
};

export const SugarContext = createContext<SugarContextType>({
  dynamicValues: getDynamicValues(),
  dashboardFilters: getDashboardFilters(),
  currentRecord: {
    module: '',
    allowCurrentRecord: false,
    showCurrentRecordFilter: false,
    updateAllowCurrentRecord: noop,
  },
});

export const SugarContextProvider = ({
  children,
  module: initModule,
  isRecordView: initIsRecordView,
  allowCurrentRecordFilter: initAllowCurrentRecordFilter,
}) => {
  const sugarContextValue = useSugarContextValues({
    initModule,
    initIsRecordView,
    initAllowCurrentRecordFilter,
  });

  return (
    <SugarContext.Provider value={sugarContextValue}>
      {children}
    </SugarContext.Provider>
  );
};

const useSugarContextValues = ({
  initModule = undefined,
  initIsRecordView = false,
  initAllowCurrentRecordFilter = false,
}): SugarContextType => {
  const dynamicValues = useDynamicValuesListener();
  const dashboardFilters = useDashboardFiltersListener();
  const currentRecord = useCurrentRecord({
    initModule,
    initIsRecordView,
    initAllowCurrentRecordFilter,
  });

  return { dynamicValues, dashboardFilters, currentRecord };
};
